import { render, staticRenderFns } from "./TemplateRemark.vue?vue&type=template&id=032d75c0&"
import script from "./TemplateRemark.vue?vue&type=script&lang=ts&"
export * from "./TemplateRemark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports